import { GetterTree } from 'vuex'
import { Things } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Things, RootState> = {
  getThings: state => {
    return state.things
  },
  getResponseError: state => {
    return state.responseError
  },
  getResponseMessage: state => {
    return state.responseMessage
  },
  getCurrentThing: state => {
    return state.currentThing
  }
}